(function(){
  var stickyCta = document.querySelector("[data-sticky-cta]");
  if (!stickyCta) return;
  var trigger = document.querySelector(".adv-vest__hero");
  var footer = document.querySelector(".adv-vest__disclosures");
  function onScroll(){
    if (!trigger) return;
    var triggerBottom = trigger.getBoundingClientRect().bottom;
    var footerTop = footer ? footer.getBoundingClientRect().top : window.innerHeight * 2;
    var shouldShow = triggerBottom < 0 && footerTop > window.innerHeight;
    stickyCta.classList.toggle("is-visible", shouldShow);
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll);
  onScroll();
})();
